import { render, staticRenderFns } from "./fairJoin.vue?vue&type=template&id=c35a9ab4&scoped=true"
import script from "./fairJoin.vue?vue&type=script&lang=js"
export * from "./fairJoin.vue?vue&type=script&lang=js"
import style0 from "./fairJoin.vue?vue&type=style&index=0&id=c35a9ab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35a9ab4",
  null
  
)

export default component.exports